import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { CheckboxInput } from 'component/Checkbox';

export const UavDropMunitions = (props) => {
  const hazardType = props.formData.info.hazard_type;

  return (
    <AccordionBodyItem
      accordionSubId="3.9"
      titleUA="Скиди з БПЛА"
      titleEN="UCAV dropped munitions"
      className={props.errors.hazard_type ? 'error' : ''}
      children={(
        <CheckboxInput
          id="uavDropMunitions"
          name="uav_drop_munitions"
          value="uav_drop_munitions"
          checked={hazardType.uav_drop_munitions}
          handleInput={props.handleContamination}
          disable="false"
        />
      )}
    />
  );
};
